class CollectionPagination extends HTMLElement {
  constructor() {
    super();

    this.paginationPoint = this.querySelector(".clc-List_Pagination");
    this.currentPage = 1;
  }

  connectedCallback() {
    this.loadMore();
  }

  loadMore() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.fetchSection();
          }
        });
      },
      { threshold: 0.8 }
    );

    observer.observe(this.paginationPoint);
  }

  fetchSection() {
    this.currentPage = this.currentPage + 1;
    const url = window.location.href + "&page=" + this.currentPage;

    fetch(url, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.text())
      .then((response) => {
        const updatedProducts = new DOMParser()
          .parseFromString(response, "text/html")
          .querySelector(".clc-List_Items").innerHTML;

        this.querySelector(".clc-List_Items").innerHTML += updatedProducts;
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

if (!customElements.get("collection-pagination")) {
  customElements.define("collection-pagination", CollectionPagination);
}
